import { render } from "./PopUp.vue?vue&type=template&id=549c87cd&scoped=true"
import script from "./PopUp.vue?vue&type=script&lang=js"
export * from "./PopUp.vue?vue&type=script&lang=js"

import "./PopUp.vue?vue&type=style&index=0&id=549c87cd&scoped=true&lang=css"

import exportComponent from "F:\\Programming_And_Stuff\\Programming\\VueJs\\reaction_time_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-549c87cd"]])

export default __exports__